export default "__VITE_ASSET__CiF0Ewqn__"